__turbopack_context__.v({
  "content": "pagination-module__4ej2qW__content",
  "ellipsis": "pagination-module__4ej2qW__ellipsis",
  "icon": "pagination-module__4ej2qW__icon",
  "linkPage": "pagination-module__4ej2qW__linkPage",
  "linkPageActive": "pagination-module__4ej2qW__linkPageActive",
  "linkPrevNext": "pagination-module__4ej2qW__linkPrevNext",
  "pagination": "pagination-module__4ej2qW__pagination",
  "srOnly": "pagination-module__4ej2qW__srOnly",
});
